function radiansToDegrees(radians) {
  return (radians * 180) / Math.PI
}
function degreesToRadians(degrees) {
  return (degrees * Math.PI) / 180
}

export function getCenterLngLat(lngLatSet) {
  const LATITUDE_IDX = 1
  const LONGITUDE_IDX = 0
  let sumX = 0
  let sumY = 0
  let sumZ = 0

  for (let i = 0; i < lngLatSet.length; i++) {
    const lat = degreesToRadians(lngLatSet[i][LATITUDE_IDX])
    const lng = degreesToRadians(lngLatSet[i][LONGITUDE_IDX])
    // sum of cartesian coordinates
    sumX += Math.cos(lat) * Math.cos(lng)
    sumY += Math.cos(lat) * Math.sin(lng)
    sumZ += Math.sin(lat)
  }

  const avgX = sumX / lngLatSet.length
  const avgY = sumY / lngLatSet.length
  const avgZ = sumZ / lngLatSet.length

  // convert average x, y, z coordinate to latitude and longitude
  const lng = Math.atan2(avgY, avgX)
  const hyp = Math.sqrt(avgX * avgX + avgY * avgY)
  const lat = Math.atan2(avgZ, hyp)

  return [radiansToDegrees(lng), radiansToDegrees(lat)]
}
